import React from 'react'
import cn from 'classnames'
import { FormattedMessage, useIntl } from 'react-intl'
import PageSection from 'js/components/PageSection'
import fonts from 'js/styles/fonts'
import { FeatureImage, FeatureImageType } from 'js/components/FeatureImage'
import { homeImages } from 'js/imageSources'
import './styles.scss'

type MissionProps = {
  heading?: React.ReactNode
  ingress?: React.ReactNode
  body?: React.ReactNode
  egress?: React.ReactNode
  image?: FeatureImageType | null
  className?: string
}

export function Mission({
  heading,
  ingress,
  body,
  egress,
  image = homeImages.missionMobile,
  className,
}: MissionProps) {
  const intl = useIntl()
  const resolvedEgress =
    egress ??
    (intl.messages['home_mission_egress'] ? (
      <FormattedMessage id="home_mission_egress" />
    ) : (
      <FormattedMessage id="home_heading" />
    ))

  return (
    <>
      <PageSection className={cn('mission-section text-center', className)}>
        <div className="grid grid-cols-8">
          <hgroup className="contents">
            <h4
              className={cn(
                'col-span-8 lg:col-span-4 lg:col-start-3',
                fonts.smallHeader,
              )}
            >
              {heading ?? <FormattedMessage id="home_mission_heading" />}
            </h4>
            <p
              className={cn(
                'col-span-8 lg:col-span-6 lg:col-start-2 lg:mx-24',
                'mb-40',
                fonts.sectionHeading,
              )}
            >
              {ingress ?? <FormattedMessage id="home_mission_ingress" />}
            </p>
          </hgroup>
        </div>
        <div className="grid grid-cols-8 lg:pb-[140px]">
          <div className="col-span-8 lg:col-span-4 lg:col-start-3">
            <p className="lg:48 mb-40">
              {body ?? <FormattedMessage id="home_mission_body" />}
            </p>
            <p className={fonts.sectionHeading}>{resolvedEgress}</p>
          </div>
        </div>
      </PageSection>
      {image ? (
        <FeatureImage image={image} className="bg-BgContent lg:hidden" />
      ) : null}
    </>
  )
}

export default Mission
